import React, { Component } from "react";
import DatePickerUI from "../UI/DatePicker-f";
import { Scrollbars } from "react-custom-scrollbars";
import imgPlaceholder from "../../assets/img/img-placeholder.png";
import HeatMap from "../HeatMap/HeatMap";
import { getCustomerDetail, getDashboardCSV } from "../../actions";
import { connect } from "react-redux";
import moment from "moment";

class CustomerWebPortalDashboard extends Component {
  state = {
    from_date: null,
    to_date: null,
    currentdata: ""
  };

  componentDidMount() {
    if (this && this.props) {
      this.props.getCustomerDetail({});
    }
  }
  changeDateHandler = (name, date) => {
    this.setState({ [name]: date });
    const dateObj = {
      from_date:
        this.state.from_date &&
        moment(this.state.from_date).format("YYYY-MM-DD"),
      to_date:
        this.state.to_date && moment(this.state.to_date).format("YYYY-MM-DD"),
      ...{ [name]: moment(date).format("YYYY-MM-DD") }
    };

    this.props.getCustomerDetail(dateObj);
  };

  getDashboardCSV = () => {
    const date = {
      from_date:
        this.state.from_date &&
        moment(this.state.from_date).format("YYYY-MM-DD"),
      to_date:
        this.state.to_date && moment(this.state.to_date).format("YYYY-MM-DD")
    };
    this.props.getDashboardCSV(date).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.csv");
      link.click();
    });
  };

  renderRateStars = rate => {
    const starts = [];
    for (let i = 0; i < 5; i++) {
      if (i < rate) {
        starts.push(
          <li key={i}>
            <i className="fa fa-star" />
          </li>
        );
      } else {
        starts.push(
          <li key={i}>
            <i className="fa fa-star deactive" />
          </li>
        );
      }
    }
    return starts;
  };

  renderBranches = restaurant => {
    const branches =
      restaurant &&
      restaurant.branches.map(branch => {
        return (
          <li key={branch.id} className="row align-center mb-25">
            <div className="col-xs-6">
              <p className="font-sm color-grey pr-15 w-500">{branch.address}</p>
            </div>
            <div className="col-xs-6 text-right">
              <span className="tag-lg min-190">
                {branch.ordersCount}/{branch.branchRevenue} SAR
              </span>
            </div>
          </li>
        );
      });
    return branches;
  };

  rendertopTenItems = restaurant => {
    const topTenItems =
      restaurant &&
      restaurant.topTenItems.map((item, i) => {
        const name = item[0];
        return (
          <li className="flex-center-y" key={name + i}>
            <strong>{i + 1}</strong>
            <p>{name}</p>
          </li>
        );
      });
    return topTenItems;
  };

  renderFeedbacks = restaurant => {
    const feedbacks =
      restaurant &&
      restaurant.tenLatestFedbacks.map(feedback => {
        return (
          <li className="flex mb-15" key={feedback.restaurantreviewsId}>
            <div
              className="image bg-img size-xs"
              style={{ backgroundImage: "url(" + imgPlaceholder + ")" }}
            />
            <p className="ml-20">{feedback.restaurantreviewsComment}</p>
          </li>
        );
      });
    return feedbacks;
  };

  render() {
    if (!this.props.data) return null;
    const { result, customerDetails } = this.props.data;

    const customerId = result && result[0];
    const restaurant =
      customerDetails && customerDetails[customerId].restaurant;
    const rate = restaurant && Math.round(restaurant.customerRate);

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-12 flex-center-y">
                <h1 className="color-grey">
                  {this.props.username}
                  's Dashboard
                </h1>
                {this.state.currentdata !== "undefined" && (
                  <ul className="stars ml-25">{this.renderRateStars(rate)}</ul>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="container inner-padding box">
          <div className="box-body">
            <div className="row">
              <div className="col-xs-8">
                <div className="row">
                  <div className="col-xs-4">
                    <DatePickerUI
                      label="From"
                      name="from_date"
                      onChange={this.changeDateHandler}
                    />
                  </div>
                  <div className="col-xs-4 ml-30">
                    <DatePickerUI
                      label="To"
                      name="to_date"
                      onChange={this.changeDateHandler}
                    />
                  </div>
                </div>
              </div>
              <div
                className="col-xs-4 text-right"
                onClick={this.getDashboardCSV}
              >
                <button className="btn filled primary min-180">Export</button>
              </div>
            </div>

            <div className="row mt-35">
              <div className="col-xs-8">
                <div className="row">
                  <div className="col-xs-7">
                    <div className="orange-cards">
                      <div className="card-header">
                        <h4>Total Number of Orders/Revenue per Branch</h4>
                      </div>
                      <div className="card-content has-scroll">
                        <Scrollbars
                          renderThumbHorizontal={() => <div />}
                          style={{ height: "251px" }}
                          autoHeightMax={"100%"}
                        >
                          {this.state.currentdata !== "undefined" && (
                            <ul style={{ marginRight: "7px" }}>
                              {this.renderBranches(restaurant)}
                            </ul>
                          )}
                        </Scrollbars>
                      </div>
                      <div className="card-meta align-center flex">
                        <div className="col-xs-6">
                          <p className="font-sm color-primary uppercase w-600">
                            All Branches
                          </p>
                        </div>
                        <div className="col-xs-6 text-right">
                          {restaurant && (
                            <span className="tag-lg min-190">
                              {restaurant.totalOrdersCount}/
                              {restaurant.totalRevenue} SAR
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-5">
                    <div className="orange-cards">
                      <div className="card-header">
                        <h4>Top 10 Ordered items</h4>
                      </div>
                      <div className="card-content bottom-border">
                        {this.state.currentdata !== "undefined" && (
                          <ul className="top-list">
                            {this.rendertopTenItems(restaurant)}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 mt-15">
                    <div className="orange-cards">
                      <div className="card-header">
                        <h4>Heat Map</h4>
                      </div>
                      {restaurant && (
                        <div
                          className="card-content bottom-border"
                          style={{ height: "280px" }}
                        >
                          <HeatMap data={restaurant.heatMap} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-4">
                <div className="orange-cards">
                  <div className="card-header">
                    <h4>Recent 10 Feedbacks</h4>
                  </div>
                  <div className="card-content bottom-border has-scroll">
                    <Scrollbars
                      renderThumbHorizontal={() => <div />}
                      style={{ height: "664px" }}
                      autoHeightMax={"100%"}
                    >
                      {this.state.currentdata !== "undefined" && (
                        <ul className="image-item font-sm w-500">
                          {this.renderFeedbacks(restaurant)}
                        </ul>
                      )}
                    </Scrollbars>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.foodna,
    username: state.auth.username
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCustomerDetail: date => dispatch(getCustomerDetail(date)),
    getDashboardCSV: date => dispatch(getDashboardCSV(date))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerWebPortalDashboard);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/Dashboard.js